import React, {useEffect} from "react";
import { SearchBox } from "@elastic/react-search-ui";

import Logo from "../Logo";

import "./style.scss";
import SearchField from "../SearchField";

function SearchHeader() {

  return (
    <div className="dsearch-search-header">
      <Logo className="dsearch-search-header__logo" />
      <SearchField className="dsearch-search-header__search" />
    </div>
  );
}

export default SearchHeader;
